<template>
    <div
        :id="
            content.columnId && content.columnId[$i18n.locale]
                ? content.columnId[$i18n.locale].current
                : content._key
        "
        class="py-0"
    >
        <v-container
            v-if="content.title && content.title[$i18n.locale]"
            fluid
            class="pa-0"
        >
            <v-row column justify-center align-center>
                <v-col cols="12" class="py-0">
                    <h2 class="form-h2--column mb-0">
                        {{ content.title[$i18n.locale] }}
                    </h2>
                </v-col>
            </v-row>
        </v-container>
        <FormCatalogRequest v-if="content.form === 'catalog'" />
        <FormContact v-if="content.form === 'contact'" />
        <FormEbookDownload v-if="content.form === 'ebook'" />
        <FormLogin v-if="content.form === 'login'" />
        <FormRegister v-if="content.form === 'register'" />
        <FormResetPassword v-if="content.form === 'resetPassword'" />
        <FormSampleRequest v-if="content.form === 'samples'" />
        <FormSetPassword v-if="content.form === 'setPassword'" />
        <FormVerifyEmail v-if="content.form === 'verifyEmail'" />
        <SampleReferenceTable v-if="content.form === 'sampleReferenceTable'" />
        <SubscriptionBox v-if="content.form === 'subscribe'" />
    </div>
</template>
<script>
import FormCatalogRequest from '~/components/forms/FormCatalog'
import FormContact from '~/components/forms/FormContact'
import FormEbookDownload from '~/components/forms/FormEbookDownload'
import FormLogin from '~/components/forms/FormLogin'
import FormRegister from '~/components/forms/FormRegister'
import FormResetPassword from '~/components/forms/FormResetPassword'
import FormSampleRequest from '~/components/forms/FormSampleRequest'
import FormSetPassword from '~/components/forms/FormSetPassword'
import FormVerifyEmail from '~/components/forms/FormVerifyEmail'
import SampleReferenceTable from '~/components/SampleReferenceTable'
import SubscriptionBox from '~/components/SubscriptionBox'

export default {
    name: 'ColumnForm',
    components: {
        FormCatalogRequest,
        FormContact,
        FormEbookDownload,
        FormLogin,
        FormRegister,
        FormResetPassword,
        FormSampleRequest,
        FormSetPassword,
        FormVerifyEmail,
        SampleReferenceTable,
        SubscriptionBox
    },
    props: {
        content: {
            type: Object,
            default: null
        }
    },
    data() {
        return {}
    }
}
</script>
